import { useCapability } from '../hooks/use-capability';

import type { ReactNode } from 'react';

export interface CapabilityGateProps {
  capability: string;
  /** Renderizado quando a capability NÃO está ativa. Default: nada. */
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Renderiza `children` somente se o User+Tenant correntes têm a capability.
 *
 * Uso típico:
 *   <CapabilityGate capability="ai-conductor-h-c">
 *     <ConductorButton />
 *   </CapabilityGate>
 *
 *   <CapabilityGate capability="documents-versioning" fallback={<UpgradeHint />}>
 *     <VersionHistory />
 *   </CapabilityGate>
 *
 * Notas:
 *   - Capabilities são fonte da verdade no Engine — UI gate é tutela visual,
 *     não segurança. Servidor ainda valida via `@RequiresCapability` antes
 *     de qualquer mutation.
 */
export function CapabilityGate({
  capability,
  fallback = null,
  children,
}: CapabilityGateProps): JSX.Element {
  const granted = useCapability(capability);
  return <>{granted ? children : fallback}</>;
}
